import { z } from 'zod';
import { agentDataQueryRecordSchema } from '../types/agent-data-queries.js';
import { templateDialectSchema } from '../types/data-connection-queries.js';

export namespace GetAgentDataConnectionQueries {
  export const paramsSchema = z.object({
    agentId: z.coerce.number(),
  });

  export const querySchema = z.object({
    brandId: z.coerce.number().optional(),
  });

  export const responseSchema = z.object({
    items: z.array(agentDataQueryRecordSchema),
  });

  export type Params = z.infer<typeof paramsSchema>;
  export type Query = z.infer<typeof querySchema>;
  export type Response = z.infer<typeof responseSchema>;
}

export namespace GetAvailableDataConnectionQueries {
  export const paramsSchema = z.object({
    agentId: z.coerce.number(),
  });

  export const querySchema = z.object({
    dataConnectionId: z.uuid(),
    brandId: z.coerce.number().optional(),
  });

  const availableQueryBaseSchema = z.object({
    id: z.uuid(),
    name: z.string(),
    description: z.string(),
    dataConnectionId: z.uuid(),
  });

  const availableQueryKindSchema = z.discriminatedUnion('queryKind', [
    z.object({
      queryKind: z.literal('template'),
      templateDialect: templateDialectSchema,
    }),
    z.object({
      queryKind: z.literal('guided'),
    }),
  ]);

  export const responseSchema = z.object({
    items: z.array(z.intersection(availableQueryBaseSchema, availableQueryKindSchema)),
  });

  export type Params = z.infer<typeof paramsSchema>;
  export type Query = z.infer<typeof querySchema>;
  export type Response = z.infer<typeof responseSchema>;
}

export namespace AttachDataConnectionQueries {
  export const paramsSchema = z.object({
    agentId: z.coerce.number(),
  });

  export const requestBodySchema = z.object({
    queryIds: z.array(z.uuid()).min(1),
    brandId: z.number().nullable().optional(),
  });

  export const responseSchema = z.object({
    success: z.boolean(),
  });

  export type Params = z.infer<typeof paramsSchema>;
  export type RequestBody = z.infer<typeof requestBodySchema>;
  export type Response = z.infer<typeof responseSchema>;
}

export namespace DetachDataConnectionQuery {
  export const paramsSchema = z.object({
    agentId: z.coerce.number(),
    queryId: z.uuid(),
  });

  export const querySchema = z.object({
    brandId: z.coerce.number().optional(),
  });

  export const responseSchema = z.object({
    success: z.boolean(),
  });

  export type Params = z.infer<typeof paramsSchema>;
  export type Query = z.infer<typeof querySchema>;
  export type Response = z.infer<typeof responseSchema>;
}

export namespace UpdateDataConnectionQueryEnabled {
  export const paramsSchema = z.object({
    agentId: z.coerce.number(),
    queryId: z.uuid(),
  });

  export const requestBodySchema = z.object({
    isEnabled: z.boolean(),
    brandId: z.number().nullable().optional(),
  });

  export const responseSchema = agentDataQueryRecordSchema;

  export type Params = z.infer<typeof paramsSchema>;
  export type RequestBody = z.infer<typeof requestBodySchema>;
  export type Response = z.infer<typeof responseSchema>;
}
